import React from 'react';

const Title = ({ children = null }) => (
  <span className="ws-ui-action-list-item__title">{children}</span>
);

export default Title;
